import { FF_ESCRIPT_NEW_PAYMENT_SUCCESS_PAGE } from '@/constants/featureFlags';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import useCustomer from '@/hooks/user/useCustomer';
import PaymentSuccessAuth from '@/pages/payment/shopify/paymentSuccessAuth';
import { EscriptOrderSuccess } from './OrderSuccess';

// TODO: RouteProps to be removed once we remove the withFeatureFlags from routes
type RouteProps = {
  [key: string]: any;
};

export default function PaymentSuccessContainer(props: RouteProps) {
  const { flags } = useFeatureFlags();
  const { data: customer } = useCustomer();
  const isEscriptCustomer = customer?.isExternal;

  if (flags[FF_ESCRIPT_NEW_PAYMENT_SUCCESS_PAGE] && isEscriptCustomer) {
    return <EscriptOrderSuccess {...props} />;
  }

  return <PaymentSuccessAuth {...props} />;
}
